import {
	compressAndBase62Encode,
	EventPagingFilterParams,
	TOfferRequest,
} from "@gp/hub";
import { getCurrentLanguage, httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ContextOptions, ApiRequestContextData } from "@utils/api-config/types";

export class ResultsHistoriesApiService {
	static baseUrl(config: ApiRequestContextData): string {
		return `${WEBPACK_OFFER_HISTORY_API_ADDRESS}/${config?.agencyKey}/results-histories`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		return getApplicationRequestHeaders(context);
	};

	private static createUrl(base: string, filter: unknown): string {
		const url = new URL(base);
		const filterWithLanguage = {
			...(filter as object),
			language: getCurrentLanguage(),
		};
		url.searchParams.set(
			"filter",
			compressAndBase62Encode(filterWithLanguage)
		);
		return url.toString();
	}

	static async getOffer<K>(
		offerFilter: TOfferRequest,
		options?: ContextOptions
	): Promise<K> {
		const context = getApiRequestContext(options);
		return await httpClient.get(
			this.createUrl(this.baseUrl(context), offerFilter),
			this.getRequestHeaders(context)
		);
	}

	static async getMenu(
		offerFilter: EventPagingFilterParams,
		options?: ContextOptions
	) {
		const context = getApiRequestContext(options);
		return await httpClient.get(
			this.createUrl(`${this.baseUrl(context)}/sport-menu`, offerFilter),
			this.getRequestHeaders(context)
		);
	}
}
